import React from 'react';
import PropTypes from "prop-types";
import {observer} from "mobx-react";
import {useSelection} from "@morningtrain/react-resources";
import {useConstrainable} from "@morningtrain/react-filters";

function SelectedFilter (props) {
  const constrainable = useConstrainable()
  const selection = useSelection()

  const [selected, setSelected] = React.useState(null)

  React.useEffect(() => {
    constrainable.setConstraint(props.name, selected)

    return () => {
      constrainable.setConstraint(props.name, null)
    }
  }, [selected])

  React.useEffect(() => {
    if (selected !== selection.selected) {
      setSelected(selection.selected)
    }
  })

  return null
}

SelectedFilter.defaultProps = {

}

SelectedFilter.propTypes = {

}

export default observer(SelectedFilter);
